<template>
  <div class="row member-offer-form">
    <h1 class="page-header text-center"> member offer </h1>
    <div v-if="alert" class="error-message text-center callout alert">{{ alert }}</div>
    <div class="medium-6 columns small-centered">
      offer type
      <div class="offer-type bonus-type">
        <label
          v-for="offer in offerOptions"
          class="offer-type-container bonus-type-container"
          :key="offer.id"
          :for="offer.id">
          <input
            v-model="offerType"
            class="offer-type-radio"
            type="radio"
            :value="offer.value"
            name="offerType"
            :disabled="!isEdit"
            :id="offer.id" />
          <span :class="[offer.value, 'radio radio-offer-type text-center']">
              {{ offer.label1 }}<br>{{ offer.label2 }}
            </span>
        </label>
      </div>
      offer name
      <input type="text"
             v-model="itemName"
             name="item_name"
             placeholder="offer name"
             maxlength="255"
      />
      <div v-if="offerType === 'bonus-points'">
        <label :class="['data-description', 'bonus-type-label']">bonus type</label>
        <div class="bonus-type">
          <label class="bonus-type-container" :for="'type-add-'+ memberOfferId">
            <input
              v-model="bonusType"
              class="bonus-type-radio"
              type="radio"
              value="add"
              :name="'bonus_type'+ memberOfferId"
              :id="'type-add-'+ memberOfferId"
              :checked="bonusType === 'add'"
              :disabled="!isEdit">
            <span class="radio add text-center">
            <span>+</span>
            <small>add</small>
          </span>
          </label>
          <label class="bonus-type-container" :for="'type-multiply-'+ memberOfferId">
            <input
              v-model="bonusType"
              class="bonus-type-radio"
              type="radio"
              value="multiply"
              :name="'bonus_type'+ memberOfferId"
              :id="'type-multiply-'+ memberOfferId"
              :checked="bonusType === 'multiply'"
              :disabled="!isEdit">
            <span class="radio multiply text-center">
            <span>x</span>
            <small>multiply</small>
          </span>
          </label>
        </div>
      </div>
      <div v-if="offerType === 'bonus-points'">
        bonus value
        <input
          v-model="bonusValue"
          value="0"
          class="bonus-value"
          type="number"
          name="bonus_value"
          min="0"
          step="1"
          :disabled="!isEdit" />
        <div
          v-if="alerts.bonus"
          class="field-alert"
        >
          {{ alerts.bonus }}
        </div>
      </div>
      <template v-if="isEdit"> member group </template>
      <group-widget
        ref="groupWidget"
        v-if="isEdit"
        v-slot="groups"
        :campaignId="memberOfferId"
        campaignType="MemberOffer"
        :headerText="groupWidgetHeaderText"
        :hideCarriersGroup="false"
        :openGroupItem="openGroupItem"
        :selectedView="selectedView"
        :scopeMerchantTagIds="merchantTagIds"
        :scopeSelectedSegmentIds="merchantSegmentIds"
        :scopeSelectedGroups="scopeSelectedGroups"
        @updateData="updateData"
        @updateScope="updateGroups"
        @updateAlerts="updateAlerts">
      </group-widget>
      POS discount ID (optional)
      <input type="text"
             v-model="meta"
             name="meta"
             placeholder="POS discount ID (optional)"
             maxlength="255"
      />
      <div class="meta_json_selection">
        <select
          v-model="rewardType"
          name="reward_type"
          class="max-redemptions"
          id="reward_type">
          <option value=""></option>
          <option value="%">%</option>
          <option value="$">$</option>
        </select>
        <input type="number"
               step="any"
               placeholder=0.00
               min=0.00
               name="reward_value"
               v-model="rewardValue"
               id="reward_value"
        />
      </div>
      days until expiration(optional)
      <input type="number"
             step="any"
             min=0.00
             name="expiry_date_in_days"
             v-model="expiryDateInDays"
             :disabled="!isEdit"
      />
      offers per customer
      <select
        v-model="maxRedemptions"
        :disabled="!isEdit"
        name="max_redemptions"
        class="max-redemptions">
        <option value="-1">unlimited</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="10">10</option>
      </select>
      <input type="checkbox"
             v-model="status"/>
      active
      <div class="image-container"
           v-if="isEdit">
        <upload-attachment :key="preloadConfig.type + memberOfferId"
                           :attachment="preloadConfig.type === 'coupon' ? couponImage : preloadImage"
                           deleteClasses="delete-image"
                           :deleteText="isEdit ? 'remove' : 'null'"
                           fileUploadClasses="image-upload"
                           :label="preloadConfig.type"
                           loadingClasses="offer-loading"
                           :ownerId="memberOfferId"
                           ownerType="MemberOffer"
                           shouldReload
                           :showInputFile="preloadConfig.type === 'coupon' ? !couponImage : !preloadImage"
                           showPreview
                           :uploadConfig="preloadConfig"
                           :disabled="!isEdit"
                           @configureAttachment="configureAttachmentResponse"
                           @reloadAttachments="loadImages">
        </upload-attachment>
      </div>
      <div class="image-container"
           v-if="isEdit && offerType === 'coupon'">
        <upload-attachment :key="couponConfig.type + memberOfferId"
                           :attachment="couponConfig.type === 'coupon' ? couponImage : preloadImage"
                           deleteClasses="delete-image"
                           :deleteText="isEdit ? 'remove' : 'null'"
                           fileUploadClasses="image-upload"
                           :label="couponConfig.type"
                           loadingClasses="offer-loading"
                           :ownerId="memberOfferId"
                           ownerType="MemberOffer"
                           shouldReload
                           :showInputFile="couponConfig.type === 'coupon' ? !couponImage : !preloadImage"
                           showPreview
                           :uploadConfig="couponConfig"
                           :disabled="!isEdit"
                           @configureAttachment="configureAttachmentResponse"
                           @reloadAttachments="loadImages">
        </upload-attachment>
      </div>
      <div class="row">
        <div class="small-12 columns center-button">
          <input
            type="submit"
            name="save-member_offer"
            value="update"
            id="member-offer-update-button"
            @click.prevent="submit"
            class="button">
        </div>
      </div>
      <div v-if="isEdit" @click="destroy" class="link-delete delete-user-link text-center">delete member offer</div>
    </div>
    <button @click="cancel" class="link-delete cancel-link">cancel</button>
    <cancel-edit-modal
      v-if="cancelModalOpen"
      @close="cancelModalOpen = false"
      @save="saveAsTemplate"
      @delete="deleteQuery"
    />
  </div>
</template>
<script>
  import CancelEditModal from './CancelEditModal';
  import GroupWidget from "../../components/GroupWidget";
  import AxiosMixin from "../../mixins/AxiosMixin";
  import UploadAttachment from "../../components/FormItems/UploadAttachment";
  import axiosConfig from '../../config/axios'
  import {isObject} from "../../utilities";

  export default {
    name: 'MemberOfferEdit',
    components: {
      GroupWidget,
      UploadAttachment,
      CancelEditModal
    },
    mixins: [AxiosMixin],
    data() {
      return {
        cancelModalOpen: false,
        alert: null,
        alerts: {},
        offerType: 'coupon',
        memberOfferId: null,
        bonusType: null,
        bonusValue: null,
        itemName: null,
        itemValue: 0,
        description: null,
        status: false,
        meta: null,
        rewardType: null,
        rewardValue: null,
        expiryDateInDays: null,
        maxRedemptions: -1,
        preloadImage: null,
        couponImage: null,
        selectedView: 'sms',
        openGroupItem: null,
        enabledAt: null,
        merchantSegmentIds: [],
        merchantTagIds: [],
        groupsWithSelected: [],
        groupWidgetHeaderText: 'all members',
        couponConfig: {
          differentLabel: 'add coupon image',
          displayType: `coupon-image-${this.memberOfferId}`,
          type: 'coupon',
        },
        preloadConfig: {
          differentLabel: 'add display image',
          displayType: `preload-image-${this.memberOfferId}`,
          type: 'preload',
        },
        offerOptions: [
          {
            id: 'coupon',
            value: 'coupon',
            label1: 'digital',
            label2: 'voucher'
          },
          {
            id: 'bonus-points',
            value: 'bonus-points',
            label1: 'bonus',
            label2: 'points'
          }
        ]
      }
    },
    mounted() {
      this.groupsCall()
      this.groupWidgetHeader();
    },
    created() {
      this.$store.dispatch('LOAD_CURRENT_USER')
      this.memberOfferId = this.$route.params.id
      if (this.memberOfferId ) {
        this.initMemberOffer()
        this.loadImages()
      }
    },
    computed: {
      isEdit: function () {
        return !!this.memberOfferId && !this.enabledAt
      },
      scopeSelectedGroups(){
        let scopedSelectedGroups = this.groupsWithSelected
        return scopedSelectedGroups;
      }
    },
    methods: {
      initMemberOffer() {
        this.$store.dispatch('LOAD_CURRENT_MERCHANT')
        this.loadMemberOffer()
      },
      afterMemberOfferLoad(data, alert) {
        const memberOfferData = data ? data.member_offer : null
        if(memberOfferData) {
          this.itemName = memberOfferData.item_name
          this.itemValue= memberOfferData.item_value
          this.description = memberOfferData.description
          this.status = memberOfferData.status
          this.meta = memberOfferData.meta
          this.rewardType = memberOfferData.reward_type
          this.rewardValue = memberOfferData.reward_value
          this.expiryDateInDays = memberOfferData.expiry_date_in_days
          this.maxRedemptions = memberOfferData.max_redemptions
          this.groupsWithSelected = memberOfferData.groups_with_selected
          this.merchantTagIds = memberOfferData.merchant_tag_ids
          this.merchantSegmentIds = memberOfferData.merchant_segment_ids
          this.enabledAt = memberOfferData.enabled_at
          this.bonusType = memberOfferData.bonus_type
          this.bonusValue = memberOfferData.bonus_value
          this.offerType = memberOfferData.bonus_type ? "bonus-points" : "coupon"
          this.modified = memberOfferData.modified
        }
        this.memberOfferLoading = false
      },
      afterUpdateGroups(data, alert) {
        const memberOfferData = data ? data.member_offer : null
        if(memberOfferData) {
          this.merchantSegmentIds = memberOfferData.merchant_segment_ids
          this.groupsWithSelected = memberOfferData.groups_with_selected
          this.merchantTagIds = memberOfferData.merchant_tag_ids
        }
        this.groupWidgetHeader()
      },
      loadMemberOffer() {
        const url = `/api/v3/member_offers/${this.memberOfferId}?legacy=true`
        this.axiosMethod({url, onSuccess: this.afterMemberOfferLoad, onError: this.setAlert})
      },
      setAlert(message = 'there was an error please refresh & try again') {
        const alerts = message.split(' and ')
        const bonusAlerts = alerts.filter(alertString => alertString.toLowerCase().includes('bonus'))
        if (bonusAlerts.length) {
          this.alerts.bonus = bonusAlerts.join(' and ');
        }
        else {
          this.alert = message;
        }
      },
      configureAttachmentResponse(responseData) {
        if (responseData.label === 'preload') {
          this.preloadImage = responseData
        } else {
          this.couponImage = responseData
        }
      },
      loadImages() {
        const url = `/api/v3/member_offers//${this.memberOfferId}/attachments`
        axiosConfig.get(url)
          .then((response) => {
            const images = response.data
            if (isObject(images)) {
              let coupon,
                preload
              this.imageError = null
              images.forEach( image => {
                if (image.label === 'coupon') { coupon = image }
                if (image.label === 'preload') { preload = image }
              })
              this.couponImage = coupon ? coupon : null
              this.preloadImage = preload ? preload : null
            } else {
              this.imageError = 'error loading reward images'
            }
          })
          .catch((error) => {
            this.imageError = `could not load reward images. ${error}`
          })
      },
      saveMemberOfferErrorHandler(error) {
        this.setAlert(error.response.data.error)
      },
      saveMemberOfferSuccessHandler(data) {
        const errors = Object.values(data.errors),
          hasErrors = errors.length > 0
        if (hasErrors) {
          this.setAlert(errors[0][0])
          return
        }
        this.goToRewards()
      },
      submit() {
        if (this.offerType === "bonus-points" && (!this.bonusType || !this.bonusValue)) {
          this.setAlert("Bonus points must have bonus type and bonus value!")
          return
        }
        this.saveQuery()
      },
      saveAsTemplate(){
        this.status = false;
        this.saveQuery()
      },
      destroy() {
        if (window.confirm('Are you sure you want to delete this member offer?')) {
          this.deleteQuery()
        }
      },
      cancel(){
        if(this.modified){
          this.goToRewards()
        } else {
          this.cancelModalOpen = true
        }
      },
      updateData(field, value) {
        this[field] = value
        this.groupWidgetHeader();
      },
      updateAlerts(itemKey, alert) {
        this.UPDATE_STATE_OBJECT({stateKey: 'alerts', itemKey, itemObject: alert})
      },
      groupsCall() {
        let url = `/api/v3/groups?legacy=true`,
          errorMessage = `could not load the filters`
        axiosConfig.get(url, {})
          .then((response) => {
            const data = response.data
            if (isObject(data)) {
              this.selectedGroups = data
            }
            this.errorMessage = errorMessage
          })
          .catch((error) => {
            this.setAlert(error.response.data.error)
          })
      },
      updateGroups(dataToUpdate) {
        const url = `/api/v3/member_offers/${this.memberOfferId}`,
          params = { member_offer: dataToUpdate },
          methodType = 'patch'
        this.axiosMethod({methodType, url, params, onSuccess: this.afterUpdateGroups, onError: this.saveMemberOfferErrorHandler})
      },
      groupWidgetHeader(){
        const groups = this.$refs.groupWidget.filterGroups || this.$refs.groupWidget.onlySelectedGroups
        if (groups?.length === 1) {
          this.groupWidgetHeaderText = groups[0].display_names.length === 1 ? groups[0].display_names[0] : 'multiple'
        } else if (groups?.length > 1) {
          this.groupWidgetHeaderText = 'multiple'
        } else {
          this.groupWidgetHeaderText = 'all members'
        }
      },
      goToRewards(){
        window.location.href = '/rewards'
      },
      deleteQuery(){
        this.axiosMethod({
          methodType: 'delete',
          url: `/api/v3/member_offers/${this.memberOfferId}`,
          onSuccess: this.saveMemberOfferSuccessHandler,
          onError: this.setAlert
        })
      },
      saveQuery(){
        this.axiosMethod({
          methodType: 'patch',
          url: `/api/v3/member_offers/${this.memberOfferId}`,
          params: {
            member_offer: {
              item_name: this.itemName,
              item_value: this.itemValue,
              description: this.description,
              status: this.status,
              meta: this.meta,
              reward_type: this.rewardType,
              reward_value: this.rewardValue,
              expiry_date_in_days: this.expiryDateInDays,
              max_redemptions: this.maxRedemptions,
              merchant_segment_ids: this.merchantSegmentIds,
              bonus_type: this.offerType === "coupon" ? null : this.bonusType,
              bonus_value: this.offerType === "coupon" ? null : this.bonusValue
            }
          },
          onSuccess: this.saveMemberOfferSuccessHandler,
          onError: this.saveMemberOfferErrorHandler,
        })
      }
    }
  }
</script>

<style>
  .member-offer-form .group-widget.filters {
    width: 100%;
    max-width: unset !important;
    position: relative;
    left: 0;
    top: 0;
    border: none;
    border-radius: 8px;
  }
  .member-offer-form .filters-header {
    height: 39px;
    padding: 0.7rem;
  }
  .member-offer-form .selected-groups {
    display: none;
  }
  .member-offer-form .recipients:before {
    content: unset !important;
  }

  .member-offer-form .filters-header .filter-header-text {
    width: 100%;
    margin-top: 0;
  }
  .member-offer-form .filters-header .filter-header-text .recipients {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 400px;
  }

  @media only screen and (max-width: 600px) {
    .member-offer-form .filters-header .filter-header-text .recipients {
      width: 300px;
    }
  }

  .member-offer-form .filters-header:after {
    content: '';
    float: right;
    font-weight: bold;
    margin-left: -30px;
    width: 0.8rem;
    height: 0.8rem;
    transform: rotate(45deg);
    border-bottom: 2px solid;
    border-right: 2px solid;
    margin-bottom: 0.4rem;
  }
  .member-offer-form .filters-header.slide-open:after {
    content: '';
    float: right;
    font-weight: bold;
    margin-left: -30px;
    width: 0.8rem;
    height: 0.8rem;
    border-bottom: 2px solid;
    border-right: 2px solid;
    transform: rotate(-135deg);
    margin-top: 0.4rem;
  }
  .member-offer-form .image-container .attachment-label {
    color:  #128FF9;
  }
  .member-offer-form .image-container {
    margin: 14px 0 14px 0;
  }
  .member-offer-form .image-preview-description {
    display: none;
  }
  .member-offer-form .delete-attachment.link-delete.delete-image {
    margin-top: 0px;
  }
  .member-offer-form .image-preview.thumbnail {
    margin-bottom: 0px;
  }
  .member-offer-form .image-preview-item {
    text-align: center;
  }
  .member-offer-form .offer-type.bonus-type {
    margin-bottom: 1rem;
  }
  .member-offer-form .group-widget-section {
    margin-bottom: 1rem;
  }
  .member-offer-form .field-alert {
    margin-top: -1rem;
    margin-bottom: 0.7rem;
    color: rgba(249, 18, 83, .5);
  }
</style>
